import { isAxiosError } from 'axios';
import { EnqueueSnackbar } from 'notistack';

import {
    displayErrorMessage,
    messageWithInterpolation,
} from './display-error-message';

export const displayErrorSnackbar = (
    e: unknown,
    enqueueSnackbar: EnqueueSnackbar,
    key?: string,
) => {
    const { errorStatus, errorMessages } = getErrorStatusAndMessage(e);

    errorMessages.map((errorMessage) => {
        enqueueSnackbar(
            `${errorStatus}: ${displayErrorMessage(errorMessage, true)}`,
            {
                variant: 'error',
                persist: true,
                key: `${key}_${errorStatus}_${errorMessage}`,
            },
        );
    });
};

export const formatErrorMessages = (e: unknown): string[] => {
    if (e === '403') {
        return [displayErrorMessage('unauthorized', true) ?? 'Unauthorized'];
    }

    const { errorStatus, errorMessages } = getErrorStatusAndMessage(e);

    return errorMessages.map(
        (errorMessage) =>
            `${errorStatus}: ${displayErrorMessage(errorMessage, true)}`,
    );
};

const getErrorStatusAndMessage = (e: unknown) => {
    let errorStatus = 500;
    let errorMessages = ['something_wrong'];

    if (isAxiosError(e)) {
        errorStatus = e?.response?.status ?? errorStatus;
        if (errorStatus === 413) {
            errorMessages = ['payload_too_big'];
        } else {
            errorMessages = e?.response?.data?.errorMessages ?? errorMessages;
        }
    } else if (e instanceof Error) {
        errorMessages = [e.message || 'unknown_error'];
    }
    return { errorStatus, errorMessages };
};
